import React from 'react';
import { Condition } from '../../form/BaseForm';

import { FormLabel, FormSelect } from '../../form';
import Pumping from './Pumping';
import Food from './Food';
import Nothing from './Nothing';
import { required } from '../../../helpers/formValidators';

export default () => {
  const feedingTypes = [
    {
      value: 'breast',
      label: 'Breast'
    },
    {
      value: 'bottle',
      label: 'Bottle'
    },
    {
      value: 'gavage',
      label: 'Gavage'
    },
    {
      value: 'nothing',
      label: 'Nothing by mouth (Oral care)'
    }
  ];
  return (
    <div>
      <FormLabel>Feeding Type</FormLabel>
      <FormSelect
        name="feedingType"
        options={feedingTypes}
        placeholder="Select"
        validate={required}
        includeOther
        otherLabel="Describe Other Feeding Type"
        otherName="otherFeedingType"
      />

      <Condition when="feedingType" is="breast">
        <Pumping />
      </Condition>

      <Condition when="feedingType" is="bottle">
        <Food foodType="bottle" />
      </Condition>

      <Condition when="feedingType" is="gavage">
        <Food foodType="gavage" />
      </Condition>

      <Condition when="feedingType" is="nothing">
        <Nothing />
      </Condition>

      <Condition when="feedingType" is="other">
        <Nothing />
      </Condition>
    </div>
  );
};
